import { AccountClient } from '@app/api2/api';
import { buildUrl, AppRoutes } from '../AppRoutes';

// Create a singleton instance of the AuthClient
export const authClient = new AccountClient();

// Helper functions for common auth operations
export const logout = async (): Promise<void> => {
    try {
        await authClient.logout();
        // Redirect to login page after logout
        window.location.href = buildUrl(AppRoutes.Login, {});
    } catch (error) {
        console.error('Logout error:', error);
        // Still redirect to login page even if logout API fails
        window.location.href = buildUrl(AppRoutes.Login, {});
    }
};

export const getCurrentUser = async () => {
    try {
        return await authClient.getCurrentUser();
    } catch (error) {
        console.error('Get current user error:', error);
        return { isAuthenticated: false };
    }
};

export default authClient;